(function () {
  if (!document.body || !document.body.classList.contains('hw-season')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NEED = 8;
  var SCARE_AT = 25;
  var PROGRESS_KEY = 'hwGhostHuntV1';
  var SCARE_KEY = 'hwGhostScareV1';
  var ghostSvg =
    '<span class="hw-ghost__boo" aria-hidden="true"><img alt=""></span>' +
    '<span class="hw-ghost__plus" aria-hidden="true">+1</span>' +
    '<span class="hw-ghost__body"><svg viewBox="0 0 64 80" aria-hidden="true"><path d="M32 6c14 0 26 12 26 32v34c0 3-4 3-6 0-3-4-6-4-9 0s-6 4-9 0-6-4-9 0-6 4-9 0c-2 3-6 3-6 0V38C6 18 18 6 32 6z"/><circle cx="24" cy="34" r="4" fill="#0a0d2b"/><circle cx="40" cy="34" r="4" fill="#0a0d2b"/></svg></span>';
  var spiderSvg =
    '<svg viewBox="0 0 40 32" aria-hidden="true"><g fill="none" stroke="#0a0d2b" stroke-width="1.8" stroke-linecap="round"><path d="M8 10 L2 4 M8 16 L1 16 M8 22 L2 28 M32 10 L38 4 M32 16 L39 16 M32 22 L38 28"/></g><ellipse cx="20" cy="16" rx="8" ry="7" fill="#0a0d2b"/><circle cx="17" cy="14" r="1.3" fill="#ffb800"/><circle cx="23" cy="14" r="1.3" fill="#ffb800"/></svg>';

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function readCaught() {
    try {
      return Math.max(0, parseInt(sessionStorage.getItem(PROGRESS_KEY) || '0', 10) || 0);
    } catch (e) {
      return 0;
    }
  }

  function writeCaught(value) {
    try {
      sessionStorage.setItem(PROGRESS_KEY, String(value));
    } catch (e) {}
  }

  function isUnlocked() {
    return typeof window.ddcIsUnlocked === 'function' ? window.ddcIsUnlocked() : document.documentElement.classList.contains('ddc-unlocked');
  }

  var ghostsRoot = document.querySelector('[data-hw-ghosts]');
  var booSrc = ghostsRoot ? ghostsRoot.getAttribute('data-hw-boo') || '' : '';
  if (ghostsRoot && ghostsRoot.getAttribute('data-hw-need')) {
    NEED = parseInt(ghostsRoot.getAttribute('data-hw-need'), 10) || 8;
  }

  var caught = readCaught();
  var dock = document.querySelector('[data-hw-dock]');
  var prize = document.querySelector('[data-hw-prize]');
  var scoreBoards = document.querySelectorAll('[data-hw-score]');
  var maxModal = document.querySelector('[data-hw-max-modal]');
  var unlockedOnce = isUnlocked() || caught >= NEED;

  function closeMaxModal() {
    if (!maxModal) return;
    maxModal.hidden = true;
  }

  function openMaxModal() {
    if (!maxModal) return;
    maxModal.hidden = false;
  }

  function offPct() {
    return Math.max(0, Math.min(NEED, caught));
  }

  function renderOff() {
    var pct = offPct();
    document.querySelectorAll('[data-hw-off]').forEach(function (el) {
      el.textContent = String(pct);
    });
  }

  function renderScore(pop) {
    document.querySelectorAll('[data-hw-caught]').forEach(function (el) {
      el.textContent = String(caught);
    });
    renderOff();
    if (pop && scoreBoards.length) {
      scoreBoards.forEach(function (board) {
        board.classList.remove('is-tick');
        void board.offsetWidth;
        board.classList.add('is-tick');
      });
    }
  }

  function setDock(unlocked) {
    if (dock) dock.hidden = !unlocked;
    if (prize) prize.hidden = !unlocked;
    if (dock) dock.classList.toggle('is-unlocked', !!unlocked);
    renderScore(false);
  }

  function scareSeen() {
    try {
      return sessionStorage.getItem(SCARE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function playBoo() {
    var Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    try {
      if (!playBoo.ctx) playBoo.ctx = new Ctx();
      var ctx = playBoo.ctx;
      if (ctx.state === 'suspended') ctx.resume();
      var now = ctx.currentTime;
      var master = ctx.createGain();
      master.gain.setValueAtTime(0.0001, now);
      master.gain.exponentialRampToValueAtTime(0.55, now + 0.08);
      master.gain.setValueAtTime(0.5, now + 0.55);
      master.gain.exponentialRampToValueAtTime(0.0001, now + 1.45);
      master.connect(ctx.destination);

      var voice = ctx.createOscillator();
      var body = ctx.createOscillator();
      var bodyGain = ctx.createGain();
      var formant = ctx.createBiquadFilter();
      voice.type = 'sine';
      body.type = 'triangle';
      voice.frequency.setValueAtTime(246, now);
      voice.frequency.linearRampToValueAtTime(196, now + 0.16);
      voice.frequency.exponentialRampToValueAtTime(124, now + 1.35);
      body.frequency.setValueAtTime(123, now);
      body.frequency.exponentialRampToValueAtTime(62, now + 1.35);
      bodyGain.gain.setValueAtTime(0.22, now);
      bodyGain.gain.linearRampToValueAtTime(0.4, now + 0.7);
      formant.type = 'lowpass';
      formant.frequency.setValueAtTime(720, now);
      formant.frequency.exponentialRampToValueAtTime(340, now + 1.2);
      formant.Q.value = 0.8;
      voice.connect(formant);
      body.connect(bodyGain);
      bodyGain.connect(formant);
      formant.connect(master);

      var breathLen = Math.floor(ctx.sampleRate * 1.2);
      var breathBuffer = ctx.createBuffer(1, breathLen, ctx.sampleRate);
      var breathData = breathBuffer.getChannelData(0);
      var i;
      for (i = 0; i < breathLen; i++) breathData[i] = Math.random() * 2 - 1;
      var breath = ctx.createBufferSource();
      var breathFilter = ctx.createBiquadFilter();
      var breathGain = ctx.createGain();
      breath.buffer = breathBuffer;
      breathFilter.type = 'bandpass';
      breathFilter.frequency.setValueAtTime(500, now);
      breathFilter.frequency.exponentialRampToValueAtTime(260, now + 1.1);
      breathFilter.Q.value = 0.7;
      breathGain.gain.setValueAtTime(0.02, now);
      breathGain.gain.linearRampToValueAtTime(0.09, now + 0.25);
      breathGain.gain.exponentialRampToValueAtTime(0.0001, now + 1.3);
      breath.connect(breathFilter);
      breathFilter.connect(breathGain);
      breathGain.connect(master);
      breath.start(now);
      breath.stop(now + 1.25);

      voice.start(now);
      body.start(now);
      voice.stop(now + 1.48);
      body.stop(now + 1.48);
    } catch (e) {}
  }

  function jumpscare() {
    if (scareSeen() || document.querySelector('.hw-jumpscare')) return;
    try {
      sessionStorage.setItem(SCARE_KEY, '1');
    } catch (e) {}
    var layer = document.createElement('div');
    layer.className = 'hw-jumpscare';
    layer.setAttribute('role', 'dialog');
    layer.setAttribute('aria-label', 'Susto');
    layer.innerHTML = '<div class="hw-jumpscare__stack"><svg class="hw-jumpscare__boo" viewBox="0 0 240 160" aria-hidden="true"><g fill="#ffffff"><path fill-rule="evenodd" d="M22 28c18-16 52-16 62 8 8 18 2 36-6 50 10 8 16 22 8 38-10 22-42 30-62 16-22-16-26-52-8-78 4-14 2-26 6-34zm28 18c-10 2-16 14-12 24 4 10 16 12 22 4 6-10 0-22-10-28zm4 46c-12 0-20 12-14 24 6 10 20 10 24-2 4-12-2-22-10-22z"/><path fill-rule="evenodd" d="M102 12c28-8 56 8 58 38 2 22-8 40-6 62 2 18-16 36-38 34-24-2-42-22-44-46-2-22 10-40 8-60 0-14 8-24 22-28zm8 36c-12 6-14 24-4 34 12 10 28 2 30-12 2-16-12-28-26-22z"/><path fill-rule="evenodd" d="M168 8c30-6 58 14 56 44-2 24-14 40-10 62 4 20-16 38-40 36-26-2-44-24-44-50 0-22 12-38 12-58 0-16 10-30 26-34zm6 40c-12 8-12 26 0 34 14 8 28-2 28-16 0-16-14-26-28-18z"/></g></svg><div class="hw-jumpscare__ghost" aria-hidden="true"><svg viewBox="0 0 64 80"><path d="M32 6c14 0 26 12 26 32v34c0 3-4 3-6 0-3-4-6-4-9 0s-6 4-9 0-6-4-9 0-6 4-9 0c-2 3-6 3-6 0V38C6 18 18 6 32 6z" fill="#ffffff"/><circle cx="24" cy="34" r="4.4" fill="#0a0d2b"/><circle cx="40" cy="34" r="4.4" fill="#0a0d2b"/></svg></div></div>';
    document.body.appendChild(layer);
    window.requestAnimationFrame(function () {
      layer.classList.add('is-on');
      if (!reduce) layer.classList.add('is-shake');
    });
    playBoo();
    var closed = false;
    function closeScare() {
      if (closed) return;
      closed = true;
      layer.classList.remove('is-on');
      window.setTimeout(function () {
        if (layer.parentNode) layer.parentNode.removeChild(layer);
      }, 260);
    }
    layer.addEventListener('click', closeScare);
    window.setTimeout(closeScare, reduce ? 900 : 1600);
  }

  function celebrate() {
    openMaxModal();
    if (dock) {
      dock.classList.add('is-burst');
      window.setTimeout(function () {
        dock.classList.remove('is-burst');
      }, 1200);
    }
    if (scoreBoards.length) {
      scoreBoards.forEach(function (board) {
        board.classList.add('is-tick');
      });
    }
  }

  function unlockPrize(fromCatch) {
    unlockedOnce = true;
    if (typeof window.ddcUnlock === 'function') window.ddcUnlock();
    else {
      document.documentElement.classList.add('ddc-unlocked');
      document.querySelectorAll('[data-ddc-secret]').forEach(function (el) {
        el.hidden = false;
        el.classList.add('is-revealed');
      });
      document.querySelectorAll('[data-ddc-teaser]').forEach(function (el) {
        el.hidden = true;
      });
    }
    setDock(true);
    if (fromCatch) celebrate();
  }

  setDock(isUnlocked() || caught >= NEED);
  if (caught >= NEED && !isUnlocked()) unlockPrize(false);

  var stars = document.querySelector('[data-hw-stars]');
  if (stars && !stars.childNodes.length) {
    var starCount = reduce ? 10 : 22;
    var s;
    for (s = 0; s < starCount; s++) {
      var star = document.createElement('span');
      star.className = 'hw-star';
      star.style.left = rand(4, 96).toFixed(1) + '%';
      star.style.top = rand(6, 58).toFixed(1) + '%';
      star.style.animationDelay = rand(0, 4).toFixed(2) + 's';
      star.style.setProperty('--ss', rand(0.6, 1.4).toFixed(2));
      stars.appendChild(star);
    }
  }

  function placeGhost(ghost, index) {
    var rtl = Math.random() > 0.5;
    ghost.className = 'hw-ghost' + (rtl ? ' hw-ghost--rtl' : '');
    ghost.classList.remove('is-boo');
    ghost.style.setProperty('--gy', rand(22, 74).toFixed(1) + 'vh');
    ghost.style.setProperty('--gs', rand(0.85, 1.35).toFixed(2));
    ghost.style.setProperty('--gdur', rand(11, 20).toFixed(1) + 's');
    ghost.style.setProperty('--gd', (typeof index === 'number' ? index * 1.1 : rand(0, 4)).toFixed(1) + 's');
    ghost.style.setProperty('--gop', rand(0.78, 0.96).toFixed(2));
    if (reduce) {
      ghost.style.left = rand(8, 82).toFixed(1) + 'vw';
      ghost.style.right = 'auto';
      ghost.style.top = rand(24, 70).toFixed(1) + 'vh';
      ghost.style.animation = 'hw-ghost-bob 3.6s ease-in-out infinite';
    } else {
      ghost.style.left = '';
      ghost.style.right = '';
      ghost.style.top = '';
      ghost.style.animation = '';
    }
  }

  function spawnGhost(index) {
    if (!ghostsRoot) return null;
    var ghost = document.createElement('button');
    ghost.type = 'button';
    ghost.setAttribute('aria-label', 'Capturar fantasma para liberar o desconto');
    ghost.innerHTML = ghostSvg;
    var booImg = ghost.querySelector('.hw-ghost__boo img');
    if (booImg && booSrc) booImg.src = booSrc;
    ghost.addEventListener('click', function (event) {
      var node = event.currentTarget;
      if (node.classList.contains('is-boo')) return;
      node.classList.add('is-boo');
      event.preventDefault();
      event.stopPropagation();
      caught += 1;
      writeCaught(caught);
      renderScore(true);
      if (!unlockedOnce && caught >= NEED) unlockPrize(true);
      if (caught === SCARE_AT) jumpscare();
      window.setTimeout(function () {
        placeGhost(node);
        window.setTimeout(function () {
          node.classList.remove('is-boo');
        }, 40);
      }, 980);
    });
    placeGhost(ghost, index);
    ghostsRoot.appendChild(ghost);
    return ghost;
  }

  if (ghostsRoot) {
    ghostsRoot.innerHTML = '';
    var live = reduce ? 4 : 7;
    var g;
    for (g = 0; g < live; g++) spawnGhost(g);
  }

  var spiders = document.querySelector('[data-hw-spiders]');
  if (spiders) {
    spiders.innerHTML = '';
    var spider = document.createElement('button');
    spider.type = 'button';
    spider.className = 'hw-spider hw-spider--corner';
    spider.setAttribute('aria-label', 'Aranha na teia: clique para ela subir');
    spider.innerHTML = '<span class="hw-spider__rope"><span class="hw-spider__silk"></span>' + spiderSvg + '</span>';
    var body = spider.querySelector('svg');
    var busy = false;
    var backTimer;

    function climbAway() {
      if (busy || spider.classList.contains('is-curl')) return;
      busy = true;
      spider.classList.add('is-flee');
      window.clearTimeout(backTimer);
      backTimer = window.setTimeout(function () {
        if (spider.classList.contains('is-curl')) return;
        spider.classList.remove('is-flee');
        window.setTimeout(function () { busy = false; }, 700);
      }, 1600);
    }

    if (body) {
      body.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        climbAway();
      });
    }
    spiders.appendChild(spider);
  }

  document.addEventListener('ddc:unlocked', function () {
    if (caught < NEED) caught = NEED;
    setDock(true);
  });

  if (maxModal) {
    maxModal.addEventListener('click', function (event) {
      if (event.target === maxModal || event.target.closest('[data-hw-max-close]')) {
        closeMaxModal();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMaxModal();
    });
  }
})();
